import PropTypes from 'prop-types';
import React from 'react';
import { APPOINTMENT_STATUS, APPOINTMENT_PAYMENT_STATUS } from '../../constants';
import {
  isReserved,
  isPaidCash,
  isPaidOnline,
  isPaidOnlineFailed,
} from '../../../../common/helpers/appointments';

const PaymentDetailsStatus = ({ serviceId, dataForStatus }) => {
  const {
    status,
    paidInShop,
    canceledBy,
    allowMultipleServices,
    payment,
    appointmentServices,
    giftCardId,
    isPartiallyRefunded,
    isFullyRefunded,
    paymentStatus,
  } = dataForStatus;

  const getStatusNameAndClass = () => {
    if (paidInShop) {
      return {
        statusName: (
          <div>
            Paid<br />
            <span className="c-status__span">Cash</span>
          </div>
        ),
        statusClass: 'c-status--green',
      };
    }

    if (!giftCardId && isPaidCash(payment)) {
      return {
        statusName: (
          <div>
            Paid<br />
            <span className="c-status__span">Cash</span>
          </div>
        ),
        statusClass: 'c-status--green',
      };
    }

    if (status === APPOINTMENT_STATUS.canceled) {
      if (!canceledBy || !canceledBy.cancelByKind) {
        return {
          statusName: 'Canceled',
          statusClass: 'c-status--grey',
        };
      }

      return {
        statusName: (
          <div>
            <span className="c-status__span">Canceled</span>
            Canceled<br />
          </div>
        ),
        statusClass: 'c-status--grey',
      };
    }

    if (isFullyRefunded) {
      return {
        statusName: 'REFUNDED',
        statusClass: 'c-status--red',
      };
    }

    if (isPartiallyRefunded) {
      return {
        statusName: 'PARTIALLY REFUNDED',
        statusClass: 'c-status--green',
      };
    }

    if (allowMultipleServices) {
      const services = appointmentServices.map(appService => appService.serviceId);
      if (services.indexOf(serviceId) === -1) {
        return {
          statusName: 'Unpaid',
          statusClass: 'c-status--red',
        };
      }
    }

    if (isReserved(payment)) {
      return {
        statusName: 'Reserved',
        statusClass: 'c-status--green',
      };
    }

    if (isPaidOnline(payment)) {
      if (paymentStatus === APPOINTMENT_PAYMENT_STATUS.partiallyPaid) {
        return {
          statusName: 'PARTIALLY PAID',
          statusClass: 'c-status--green',
        };
      }
      
      return {
        statusName: 'Paid',
        statusClass: 'c-status--green',
      };
    }

    if (isPaidOnlineFailed(payment)) {
      return {
        statusName: 'PAYMENT FAILED',
        statusClass: 'c-status--red',
      };
    }

    return {
      statusName: 'Unpaid',
      statusClass: 'c-status--red',
    };
  };

  const serviceStatus = getStatusNameAndClass();

  return (
    <div className={`c-status ${serviceStatus.statusClass}`}>{ serviceStatus.statusName }</div>
  );
};

PaymentDetailsStatus.propTypes = {
  serviceId: PropTypes.string.isRequired,
  dataForStatus: PropTypes.object.isRequired,
};

export default PaymentDetailsStatus;
